import * as t from './types';

export const setDarylsEasterEgg = isActive => ({
	type: t.DARYLS_EASTEREGG,
	payload: isActive
});
